/**
 * Data Transfer Object (DTO) for payment terms.
 * This is the wire format used by the API for both requests and responses.
 */

/**
 * Base DTO enum for payment terms.
 * Represents the wire format used by the backend API.
 * This is the single source of truth for API communication.
 */
export enum PaymentTermsDTO {
  NET_7 = 'NET_7',
  NET_15 = 'NET_15',
  NET_30 = 'NET_30',
  NET_45 = 'NET_45',
  NET_60 = 'NET_60',
  NET_90 = 'NET_90',
  EOM = 'EOM',
  CIA = 'CIA',
  COD = 'COD',
  CWO = 'CWO',
}

/**
 * Type alias for payment terms in API requests.
 * Uses the base DTO enum.
 */
export type PaymentTermsRequest = PaymentTermsDTO;

/**
 * Type alias for payment terms in API responses.
 * Uses the base DTO enum.
 */
export type PaymentTermsResponse = PaymentTermsDTO;
